import themeConstants from '../../../../layout/Theme';

const styles = () => ({
  restaurantImg: {
    objectPosition: 'center',
    objectFit: 'cover',
  },
  restaurantBrand: {
    borderRadius: '0px 0px 24px 24px',
    backgroundColor: themeConstants.colors.contrastText,
  },
  socialButton: {
    borderRadius: '30px',
    width: '45px',
    height: '45px',
    backgroundColor: '#F1F1F1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  displayHours: {
    color: themeConstants.colors.fullRed,
    fontWeight: 600,
  },
});

export default styles;
